/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';

import { Grid } from 'semantic-ui-react';
import { matchPath } from 'react-router';
import { Icon } from '@redturtle/iovisit-theme/components';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { VariationWrapper, ImageListing } from '@redturtle/iovisit-theme/components';
import config from '@plone/registry';

const LinkCardVariation = (data) => {
  const {
    items,
    isEditMode,
    card_background_color = 'white',
    show_title = false,
    title,
  } = data;

  return (
    <VariationWrapper {...data} variation="link-card">
      {show_title && (
        <div className="block-title">
          <h2>{title}</h2>
        </div>
      )}
      <Grid stackable>
        {items.map((item, index) => {
          let url = item.getURL || item['@id'] || null;

          const isBlacklisted =
            (config.settings.externalRoutes ?? []).find((route) =>
              matchPath(flattenToAppURL(url), route.match),
            )?.length > 0;
          const isExternal = !isInternalURL(url) || isBlacklisted;

          return (
            <Grid.Column
              tablet={12}
              computer={6}
              widescreen={6}
              largeScreen={6}
              key={index}
            >
              <UniversalLink
                item={!isEditMode ? item : null}
                href={isEditMode ? '#' : url ? flattenToAppURL(url) : null}
              >
                <div
                  className={`card-wrapper group-hover bg-${card_background_color}`}
                >
                  <figure>
                    <ImageListing item={item} />
                  </figure>
                  <div className="card-body">
                    <div className="card-title">
                      {item.title}{' '}
                      {isExternal && (
                        <Icon
                          prefix="fas"
                          icon="external-link-alt"
                          className="icon"
                          size="xs"
                        />
                      )}
                    </div>
                    {item.description && (
                      <div className="card-description">{item.description}</div>
                    )}
                  </div>
                </div>
              </UniversalLink>
            </Grid.Column>
          );
        })}
      </Grid>
    </VariationWrapper>
  );
};

export default LinkCardVariation;
